import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/login');
  };

  return (
    <section style={{
      padding: '20px 0',
      fontFamily: 'Arial, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '0 15px',
      }}>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          marginLeft: '-15px',
          marginRight: '-15px',
        }}>
          <div style={{ width: '100%' }}>
            <div style={{
              width: '83.33333333%',
              marginLeft: '8.33333333%',
              textAlign: 'center',
            }}>
              <div style={{
                backgroundImage: 'url(https://cdn.dribbble.com/users/722246/screenshots/3066818/404-page.gif)',
                height: '300px',
                width: '100%',
                maxWidth: '500px',
                margin: '0 auto',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}></div>
              <div style={{
                marginTop: '20px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}>
                <h3 style={{
                  fontSize: '1.8rem',
                  color: '#1C2526',
                  marginBottom: '0.5rem',
                }}>Looks like you're not authorized</h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#1C2526',
                  marginBottom: '1rem',
                }}>The page you are trying to access is restricted!</p>
                <button
                  onClick={handleGoToLogin}
                  style={{
                    width: '150px',
                    padding: '0.8rem',
                    background: 'linear-gradient(to right, #FF4500, #FFA500)',
                    border: 'none',
                    borderRadius: '5px',
                    color: '#ffffff',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    height: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Go to Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Unauthorized;